import { Box, Grid } from '@mui/material';
import BlockProps from '../../../models/BlockProps';
import Utils from '../../../utils/Utils';
import CloseButton from '../../Buttons/Close';
import EditableText from '../../Form/EditableText';
import BlockLinedTitleData from './BlockLinedTitleData';
import { ColorPickerColors, ColorPickerColorsMap } from '../../../models/ColorPicker';

function BlockLinedTitle({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockLinedTitleData);

  const handleUpdate = (text: string) => {
    props.title.value = text;
    editHandler(data.id, props);
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: 120,
        p: isEditing || isTemplate ? 2 : 0,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          borderTop: `2px solid ${ColorPickerColorsMap[ColorPickerColors.BLUE]}`,
          borderBottom: `2px solid ${ColorPickerColorsMap[ColorPickerColors.BLUE]}`,
          width: '100%',
          py: 1,
        }}
      >
        <Box
          sx={{
            borderTop: `1px solid ${ColorPickerColorsMap[ColorPickerColors.BLUE]}`,
            borderBottom: `1px solid ${ColorPickerColorsMap[ColorPickerColors.BLUE]}`,
            width: '100%',
            py: isEditing || isTemplate ? 1 : 0,
          }}
        >
          {props.title && (
            <Grid item sx={[Utils.hoverBorder(isEditing), { width: '100%' }]}>
              <CloseButton
                show={isEditing}
                updateHandler={() => {
                  props.title = undefined;
                  editHandler(data.id, props);
                }}
              />
              <EditableText
                text={props.title.value}
                isEditable={isEditing && !isTemplate}
                updateHandler={handleUpdate}
              />
            </Grid>
          )}
        </Box>
      </Box>

    </Grid>
  );
}

export default BlockLinedTitle;
